import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-loading',
  templateUrl: './report-loading.component.html',
  styleUrls: ['./report-loading.component.scss']
})
export class ReportLoadingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
